import { ZfStack, ZfTooltip, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useApplicationVersion } from '../../api';
import { LogoIcon } from '../icons/LogoIcon';

export const Info: FunctionComponent = () => {
    const { t } = useTranslation();
    const { data: version } = useApplicationVersion();

    return (
        <ZfStack
            direction="row"
            alignment="center"
            justify="space-between"
            style={{
                flex: 1,
                position: 'relative',
                paddingLeft: 'var(--padding-left-xl)',
                paddingRight: 'var(--padding-right-xl)',
            }}
        >
            <ZfTooltip text={version ? `Version: ${version}` : ''} side="right" color="neutral">
                <ZfTypography slot="anchor" variant="heading-small" weight="bold" style={{ color: 'var(--fg-color-brand-normal)' }}>
                    {t('appTitle')}
                </ZfTypography>
            </ZfTooltip>
            <LogoIcon style={{ width: 136, height: 27, position: 'absolute', left: `calc(50% - 68px)` }} viewBox="0 0 136 27" />
            <div />
        </ZfStack>
    );
};
